// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "time_entry_break".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { timeEntrySourceValues } from '@borradh-workspace/labels';
/** Response atom for the "time_entry_break" table (1:1 with a DB row, on the wire). */
export const timeEntryBreakAtomSchema = z.object({
    id: z.string(),
    timeEntryId: z.string(),
    breakStart: z.string().datetime(),
    breakEnd: z.string().datetime().nullable(),
    source: z.enum(timeEntrySourceValues),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=timeEntryBreak.js.map